/**
 * @ngdoc service
 * @kind function
 * @name eventix.common.services.stateChangeErrorService
 * @description
 * Handle State Change Errors
 *
 * When a state dependency doesn't resolve, an error is thrown and the page refuses
 * to load. Use this service to store the error and offer a retry to user.
 *
 * Relies on SessionStorage to persist error across refreshes. This allows a developer
 * to fix an issue and retry the state transition.
 *
 * @param {Object} state A state definition from UI-Router
 * @param {Object} params A simple map of state parameters
 * @param {Error} error The error thrown
 */
export default angular.module('eventix.common.services.stateChangeErrorService',[])
    .factory('stateChangeErrorService', function($state, $window, store) {
        var error = store.get('stateChangeError') || {};
        function handler(state, params, err) {
            error = {
                state: _.chain(state).pick(['url','name','resolve']).mapValues((v,k) => {
                    if(k !== 'resolve') return v;
                    return _.keys(v);
                }).value(),
                params: params,
                error: formatResolveError(err)
            };
            if(err && err.stack)
                error.error.stack = err.stack.split('\n');
            store.set('stateChangeError', error);
        }

        function formatResolveError(err) {
            if(err instanceof Error) {
                return {
                    source: 'client',
                    type: err.constructor.name,
                    message: err.message
                };
            } else if( _.has(err, 'headers') && _.has(err, 'status') ) {
            // Ducktype error as a $http error
                return {
                    source: 'server',
                    type: err.status,
                    message: err.statusText
                };
            }
            return err;
        }

        /**
     * @ngdoc method
     * @name eventix.common.services.stateChangeErrorService#retry
     * @methodOf eventix.common.services.stateChangeErrorService
     * @description
     * Retry the state change, using the same parameters.
     */
        handler.retry = function() {
            if(_.isEmpty(error)) return;
            if(!this.retries)
                this.retries = 0;
            this.retries++;
            $state.go(error.state.name, error.params);
        };

        /**
     * @ngdoc method
     * @name eventix.common.services.stateChangeErrorService#get
     * @methodOf eventix.common.services.stateChangeErrorService
     * @description
     * Get the error details
     *
     * @returns {Object} Error details
     * <pre>
     * {
     *    state: {
     *      url: '/dashboard/tickets/:guid',
     *      name: 'eventix.dashboard.ticket.edit',
     *      resolve: ['ticket','event']
     *    },
     *    params: {
     *      guid: '0c4f1d42-c645-4add-b8b7-05e30b0a3ca1'
     *    },
     *    error: { .... }
     * }
     * </pre>
     */
        handler.get = function() {
            return error;
        };

        return handler;
    }).name;
